var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaCinline = function SvgLaCinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.204 19.02A3.964 3.964 0 0 0 14.043 22h.784a4.366 4.366 0 0 0 4.36-4.36v-.113l-2.983 1.493ZM15.452 18.092a3.946 3.946 0 0 1-.778-.37 3.868 3.868 0 0 1-1.733-2.368l-3.663 2.094c-.42.239-.722.63-.856 1.082.66.129 1.266.45 1.752.936.635.635 1 1.514 1 2.413V22h1.686a5.155 5.155 0 0 1 2.592-3.908Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76 19.64a.587.587 0 0 1-.587-.587c0-1.082.583-2.088 1.522-2.624l5.865-3.309c.294-.16.604-.278.923-.356-4.643-2.646-10.726.822-10.67 6.288A2.945 2.945 0 0 0 7.758 22H10v-.12a2.24 2.24 0 0 0-2.239-2.24Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.118 14.152-1.097.594c.223 1.813 2.197 2.955 3.917 2.094l1.227-.614c-.252-1.94-2.365-2.984-4.046-2.074ZM14.517 6.21H9.483c-1.201 1.926.244 4.502 2.517 4.481 2.273.021 3.719-2.555 2.517-4.48Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88 7.744c0-.9.285-1.754.824-2.473a.587.587 0 0 1 .47-.234h5.653c.184 0 .358.087.469.234 1.392 1.78.944 4.517-.847 5.785 1.146.35 2.21.947 3.12 1.76.069.021.137.044.206.068v-5.14c-.3-7.659-11.25-7.659-11.549 0v5.261a8.32 8.32 0 0 1 3.328-1.947 4.117 4.117 0 0 1-1.675-3.314Z",
    fill: "#000"
  })));
};
export default SvgLaCinline;